module.exports = __webpack_public_path__ + "static/la-ventures--aris-acoba-9e8357f8bf01b71cc1a3338216c941e0.mp4";